/**
 * The onboarding summary's arithmetic. The questions and their options are authored in
 * `assets/onboarding`'s `@onboarding/intro` files.
 */

/** Days the summary's "in 3 months" spans. */
const THREE_MONTHS_DAYS = 90;
/**
 * New characters a minute of daily study carries, roughly: a lesson and its first reviews take a
 * couple of minutes per character once reviews of earlier ones share the time.
 */
const NEW_CHARACTERS_PER_DAILY_MINUTE = 0.5;
/** Rounded down to this, so the estimate reads as one ("about 450"), not a promise ("452"). */
const ESTIMATE_ROUNDING = 50;

/** About how many characters `dailyGoalMinutes` a day reaches in three months. */
export function estimateCharactersInThreeMonths(dailyGoalMinutes: number): number {
  const characters = dailyGoalMinutes * NEW_CHARACTERS_PER_DAILY_MINUTE * THREE_MONTHS_DAYS;
  return Math.max(
    ESTIMATE_ROUNDING,
    Math.floor(characters / ESTIMATE_ROUNDING) * ESTIMATE_ROUNDING,
  );
}
